import { useState, useEffect, useCallback } from 'react';
import { logError, logInfo } from '../../../../../utils/logger';

export const useLocationTracking = () => {
  const [userLocation, setUserLocation] = useState(null);
  const [locationStatus, setLocationStatus] = useState('checking');
  const [isLocked, setIsLocked] = useState(true);
  const [hasSignal, setHasSignal] = useState(false);

  useEffect(() => {
    let watchId = null;

    const startTracking = () => {
      if (!navigator.geolocation) {
        setLocationStatus('unavailable');
        return;
      }

      watchId = navigator.geolocation.watchPosition(
        (position) => {
          const newLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            accuracy: position.coords.accuracy,
            timestamp: new Date().toISOString()
          };
          setUserLocation(newLocation);
          setLocationStatus('available');
          setHasSignal(true);
          logInfo('Location updated');
        },
        (error) => {
          logError('Location error:', error);
          setHasSignal(false);
          setLocationStatus('error');
        },
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0
        }
      );
    };

    startTracking();

    return () => {
      if (watchId) {
        navigator.geolocation.clearWatch(watchId);
      }
    };
  }, []);

  const toggleLock = useCallback(() => {
    setIsLocked(prev => !prev);
    logInfo(`Location lock ${!isLocked ? 'enabled' : 'disabled'}`);
  }, [isLocked]);

  return {
    userLocation,
    locationStatus,
    isLocked,
    hasSignal,
    toggleLock
  };
};